/**
 * ? @description : Audio Approved Teachers List
 */

// Dependencies
import React, { Fragment, memo, useEffect, useState } from "react";
import {
  Stack,
  List,
  ListItem,
  ListItemText,
  Avatar,
  ListItemAvatar,
  Typography,
  Alert,
} from "@mui/material";

//Axios
import Axios from "../../../../axios/Axios";

//Redux
import { showSnackbar } from "../../../redux/features/appSlice";
import { useDispatch } from "react-redux";
import axios from "axios";
import '../../../../css/Dashboard.css'

function AudioApprovedTeachers() {

  const dispatch = useDispatch();
  const [audioApprovedList, setAudioApprovedList] = useState([]);

  // TODO : Random Color Generation
  // function randomColor() {
  //   let letters = "0123456789ABCDEF";
  //   let color = "#";

  //   for (let i = 0; i < 6; i++) {
  //     color += letters[Math.floor(Math.random() * 16)];
  //   }

  //   return color;
  // }

  useEffect(() => {
    const controller = axios.CancelToken.source();
    (async () => {
      try{
        const options = {
          method: "get",
          url: `dashboard/approvedteacherlist`,
          auth: true,
          data: null,
          token:{cancelToken: controller.token}
        };
  
        const response = await Axios(
          options.method,
          options.url,
          options.auth,
          options.data,
          options.token,
          );
        // console.log(response);
        if(response.status === 200){
          setAudioApprovedList(response.data)
        }
      }catch(error){
        // console.log(error);
        if(!axios.isCancel(error)){ 
          dispatch(
            showSnackbar({
              message: "Couldn't able to retrieve approved audio teachers list",
              severity: "error",
            })
          );}
      }
    })()
    return () => {
      controller.cancel();
  }
  },[dispatch])
// console.log(audioApprovedList);
  return (
    <Fragment>
      <Typography variant="h6" component="div" color="primary">
        Unmapped teachers ({audioApprovedList.length})
      </Typography>

      <Stack className="unMappedTeacher">
        {audioApprovedList.length !== 0 ? audioApprovedList?.map((teacher, index) => {
          return (
            <List key={index}>
              <ListItem>
                <ListItemAvatar>
                  <Avatar/>
                </ListItemAvatar>
                <ListItemText primary={teacher.teacher_name} />
              </ListItem>
            </List>
          );
        }) : 
        <Alert
         severity="info"
         sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          mt: "30%",
          backgroundColor: "inherit"
         }}
        >No Data Available</Alert>
        }
      </Stack>
    </Fragment>
  );
}

export default memo(AudioApprovedTeachers);
